import React, { useMemo } from 'react'

import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import { listarCargosComDescricao } from '../_helpers/cargoEngine'
import { HEADING_COLOR } from '../_helpers/brand'
import { RedDataCell, RedHeadCell, RedRow, RedTable } from './_shared/BradescoTable'

/**
 * Seção 6 - Descrição das Atividades: tabela Cargo x Descrição do cargo, uma linha por
 * cargo respondido na atividade (até 20, ver CARGO_QUESTION_IDS).
 */
const DescricaoAtividadesSection = ({ serviceOrder, assets }) => {
  const cargos = useMemo(() => listarCargosComDescricao(serviceOrder.replies, assets), [serviceOrder.replies, assets])

  return (
    <View id="6">
      <Separator weight={15} />
      <Text bold size="small" color={HEADING_COLOR}>
        6. DESCRIÇÃO DAS ATIVIDADES
      </Text>
      <Separator weight={8} />

      <RedTable width="100%">
        <RedRow>
          <RedHeadCell width="30%">Cargo</RedHeadCell>
          <RedHeadCell>Descrição do cargo</RedHeadCell>
        </RedRow>

        {cargos.map(({ cargo, descricaoCargo }, index) => (
          <RedRow key={cargo} striped={index % 2 === 1}>
            <RedDataCell align="left">{cargo}</RedDataCell>
            <RedDataCell align="left">{descricaoCargo}</RedDataCell>
          </RedRow>
        ))}
      </RedTable>

      <Separator weight={15} />
    </View>
  )
}

export default DescricaoAtividadesSection
